import { z } from "zod";
import { ZodIban } from "../zod-types/zod-iban";
import { ZodStringNullable } from "../zod-types/zod-string-nullable";

/** One bank account a contact is paid on. */
export const contactBankAccountSchema = z.object({
	iban: ZodIban,
	bic: ZodStringNullable,
	accountHolder: ZodStringNullable,
	bankName: ZodStringNullable,
	isDefault: z.boolean(),
});

export type ContactBankAccountSchema = z.infer<typeof contactBankAccountSchema>;
